import { render, staticRenderFns } from "./PontoReferencia.vue?vue&type=template&id=01e058ce&"
import script from "./PontoReferencia.vue?vue&type=script&lang=js&"
export * from "./PontoReferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports